import APIUtils from '@spothero/utils/api';

const LicensePlateAPI = {
    add({userId, data}) {
        return APIUtils.post(`users/${userId}/license-plates/`, data);
    },

    remove({userId, plateId}) {
        return APIUtils.delete(`users/${userId}/license-plates/${plateId}/`);
    },

    setAsDefault({userId, plateId}) {
        return APIUtils.patch(`users/${userId}/license-plates/${plateId}/`, {
            is_default: true, // eslint-disable-line camelcase
        });
    },
};

export default LicensePlateAPI;
